import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';
import { installAxiosInterceptors } from './api/axiosInterceptors';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-teal/theme.css"; 
import 'bootstrap/dist/css/bootstrap.css'; 
// import './theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';  

installAxiosInterceptors();


ReactDOM.render(
  <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
